import React from "react";

import YouTube from "react-youtube";

import General from "../../utils/General";

export default class VideoPlayer extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      videoSource: props.videoSource,
      videoUrl: props.videoUrl
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  render() {
    let {
      videoSource,
      videoUrl
    } = this.state

    let sourceLinks = ["youtube", "vimeo", "wistia", "rumble", "jwplayer"]
    let {type, id: videoId} = sourceLinks.some(source => videoUrl?.includes(source)) ? General.getVideoInfo(videoUrl) : {type: videoSource, id: videoUrl}

    switch (videoSource) {
      case "youtube":
        return (
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube-nocookie.com/embed/${videoId}?controls=0&autoplay=1&showinfo=0&mute=0&loop=1&playlist=${videoId}`}
            frameBorder="0"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
          />
        );
      case "vimeo":
        return (
          <iframe
            width="100%"
            height="100%"
            src={`https://player.vimeo.com/video/${videoId}`}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        );
      case "wistia":
        return (
          <iframe
            width="100%"
            height="100%"
            src={`https://fast.wistia.net/embed/iframe/${videoId}`}
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
          />
        );
      case "rumble":
        return (
          <iframe
            width="100%"
            height="100%"
            src={`https://rumble.com/embed/${videoId}/?pub=4`}
            frameBorder="0"
            allowFullScreen
          />
        );
      case "jwp":
        return (
          <iframe
            width="100%"
            height="100%"
            src={`https://cdn.jwplayer.com/players/${videoId}.html`}
            frameBorder="0"
            allowFullScreen
          />
        );
      case "html5":
        return (
          <video width="100%" height="100%" controls>
            <source src={videoId} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        );
      default:
        return <p>Unsupported video source</p>;
    }

  }

}
